/** Allowed garment/print uploads: PNG, JPEG, WebP only. Magic-byte sniff, not the file label. */

export const MAX_DESIGN_UPLOAD_BYTES = 8 * 1024 * 1024
export const MAX_PRINT_UPLOAD_BYTES = 12 * 1024 * 1024

export function sniffImageBytes(bytes) {
  if (!bytes || bytes.length < 12) return null
  if (
    bytes[0] === 0x89 &&
    bytes[1] === 0x50 &&
    bytes[2] === 0x4e &&
    bytes[3] === 0x47 &&
    bytes[4] === 0x0d &&
    bytes[5] === 0x0a &&
    bytes[6] === 0x1a &&
    bytes[7] === 0x0a
  ) {
    return { mime: 'image/png', ext: 'png' }
  }
  if (bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) {
    return { mime: 'image/jpeg', ext: 'jpg' }
  }
  if (
    bytes[0] === 0x52 &&
    bytes[1] === 0x49 &&
    bytes[2] === 0x46 &&
    bytes[3] === 0x46 &&
    bytes[8] === 0x57 &&
    bytes[9] === 0x45 &&
    bytes[10] === 0x42 &&
    bytes[11] === 0x50
  ) {
    return { mime: 'image/webp', ext: 'webp' }
  }
  return null
}

export async function assertAllowedImageBlob(blob, maxBytes = MAX_DESIGN_UPLOAD_BYTES) {
  if (!blob) {
    throw new Error('No image file provided.')
  }
  const size = Number(blob.size) || 0
  if (size <= 0) {
    throw new Error('Image file is empty.')
  }
  if (size > maxBytes) {
    const mb = Math.round(maxBytes / (1024 * 1024))
    throw new Error(`Image is too large. Maximum size is ${mb} MB.`)
  }
  const bytes = new Uint8Array(await blob.arrayBuffer())
  const kind = sniffImageBytes(bytes)
  if (!kind) {
    throw new Error('Only PNG, JPEG, and WebP images are allowed.')
  }
  return { bytes, mime: kind.mime, ext: kind.ext, size }
}
